import * as React from 'react';
import * as moment from 'moment';
import * as Cookies from 'universal-cookie';
import { connect, Dispatch } from 'react-redux';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import { Modal, Button, Alert, Panel } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { detect } from 'detect-browser';
import { IBaseResponse, ICenterBase, IToken, IUser } from '@nkr/models/index';
import { DisplayType, OrganType } from '@nkr/enums/index';
import {
    IApplicationState, IAppState, AppActionCreators, IAuthState, AuthActionCreators, IAuthCheck, ICenterResponse,
    CenterNotificationActionCreators, ICenterNotificationListResponse, ICenterNotificationState, IBasicCenterListResponse, CenterActionCreators
} from '@nkr/store/index';
import { NavMenu } from './navigation';
import { LoadingIndicator } from './loading-indicator';
import CenterNotifications from './center-notifications';

interface IOwnProps extends RouteComponentProps<{ centerId: string }> { }

interface IStateProps {
    app: IAppState,
    centerNotifications: ICenterNotificationState,
    auth: IAuthState,
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    storeAuth: (token: IToken, tokenHex: string) => void,
    validToken: () => boolean,
    setUserProfile: (user: IUser) => void,
    refreshToken: () => Promise<IAuthCheck>,
    showAlert: (title: string, message: string | JSX.Element) => void,
    hideAlert: () => void,
    changeDisplay: (display: DisplayType) => void,
    getBaseCenter: (centerId: number) => Promise<ICenterResponse>,
    getBasicCenterList: (liverOnly: boolean) => Promise<IBasicCenterListResponse>
    getCenterNotifications: (centerId: number) => Promise<ICenterNotificationListResponse>,
    markNotificationRead: (id: number) => Promise<IBaseResponse>,
    setSite: (payload: { domain: string, organ: string, organType: OrganType }) => void
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    authorizationChecked: boolean;
    redirectToLogin: boolean;
    showSessionDialog: boolean;
    minutesRemaining: number;
    centerAlias: string,
    centerList: ICenterBase[]
    showNotifications: boolean
}

const initialState: IState = {
    authorizationChecked: false,
    redirectToLogin: false,
    showSessionDialog: false,
    minutesRemaining: 0,
    centerAlias: '',
    centerList: [],
    showNotifications: false
}

class Layout extends React.Component<TProps, IState> {
    readonly state: IState = initialState;
    timer: any;
    notificationTimer: any;
    sessionStart: any;
    hasCenterAlias: boolean;
    container: HTMLDivElement;

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    componentWillMount() {
        var cookies = new Cookies();
        var nkrAuth = cookies.get('NkrAuth');
        var nkrSession = cookies.get('NkrSession');
        var nkrSite = cookies.get('NkrSite');
        var redirect = false;

        if (nkrAuth == null) {
            try {
                var ssAuth = sessionStorage.getItem('NkrAuth');
                if (ssAuth) nkrAuth = JSON.parse(ssAuth);
                var ssSession = sessionStorage.getItem('NkrSession');
                if (ssSession) nkrSession = ssSession;
                var ssSite = sessionStorage.getItem('NkrSite');
                if (ssSite) nkrSite = JSON.parse(ssSite);
            } catch (e) {}
        }

        if (nkrAuth != null) {
            let { token, user } = nkrAuth;

            if (this.props.auth.isAuthenticated || nkrAuth != null) {
                this.props.storeAuth(token, nkrSession);

                if (this.props.validToken()) {
                    if (this.props.app.user == null) {
                        if (user != null) {
                            this.props.setUserProfile(user);

                            if (nkrSite != null) {
                                let { domain, organ, organType } = nkrSite;
                                this.props.setSite({ domain, organ, organType });
                            }

                            if (user.centerAlias) {
                                this.hasCenterAlias = true;
                            }
                        }
                    }
                } else {
                    redirect = true;
                }
            } else {
                redirect = true;
            }
        } else if (this.props.auth.isAuthenticated && this.props.validToken()) {
            // Redux already has valid auth (e.g., just logged in via SPA navigation).
            // NkrAuth cookie may be unavailable (size, domain scope, or timing).
            if (this.props.app.user == null) {
                var nkrSiteFallback = cookies.get('NkrSite');
                if (nkrSiteFallback != null) {
                    let { domain, organ, organType } = nkrSiteFallback;
                    this.props.setSite({ domain, organ, organType });
                }
            }
        } else {
            redirect = true;
        }

        if (redirect) {
            this.setState({
                redirectToLogin: true
            });
        }
    }

    componentDidMount() {
        let locationRequiresLogin = __NO_LOGIN_ADDRESSES__.indexOf(this.props.location.pathname) < 0;
        let countdownIntervalCheck = 15;

        this.sessionStart = moment().add(countdownIntervalCheck, 'minute');
        this.timer = window.setInterval(this.checkSession, 1000);

        this.notificationTimer = __ENVIRONMENT__ == 'dev' || locationRequiresLogin == false ? null : window.setInterval(this.checkForNotifications, 2000);

        // if (this.props.location.pathname.indexOf('/admin/centers') < 0) {
        //     document.addEventListener('click', this.resetSession);
        // }

        if (!this.hasCenterAlias) {
            if (this.props.match.params.centerId) {
                this.props.getBaseCenter(parseInt(this.props.match.params.centerId)).then(response => {
                    this.setState({
                        centerAlias: response.data.results.alias
                    });
                });
            }
        }
    }

    componentWillUnmount() {
        window.clearInterval(this.timer);
        document.removeEventListener('click', this.resetSession);
    }

    checkSession = () => {
        const remainingTime: any = this.getRemainingTime();

        if (remainingTime.minutes <= 1 && remainingTime.seconds <= 5) {
            window.clearInterval(this.timer);
            document.removeEventListener('click', this.resetSession);

            this.setState({
                showSessionDialog: true
            });
        }
    }

    getRemainingTime = () => {
        var now = moment.utc();
        var minutes = this.sessionStart.diff(now, 'minutes')
        var seconds = this.sessionStart.diff(now, 'seconds') - (minutes * 60);

        return {
            minutes,
            seconds
        };
    }

    resetSession = () => {
        const countdownIntervalCheck = 15;

        window.clearInterval(this.timer);

        this.props.refreshToken();
        this.sessionStart = moment().add(countdownIntervalCheck, 'minute');
        this.timer = window.setInterval(this.checkSession, countdownIntervalCheck * 1000);

        document.addEventListener('click', this.resetSession);
    }

    checkForNotifications = () => {
        if (this.props.match.params.centerId) {
            window.clearInterval(this.notificationTimer);

            this.props.getCenterNotifications(parseInt(this.props.match.params.centerId)).then(response => {
                // let centerNotifications = this.props.centerNotifications.list.filter(x => x.isEnabled == true && x.isRead == false);
                this.notificationTimer = window.setInterval(this.checkForNotifications, 60000);
            });
        }
    }

    handleContinueSession = () => {
        this.setState({
            showSessionDialog: false
        }, () => {
            this.resetSession();
        });
    }

    handleLogin = () => {
        this.setState({
            showSessionDialog: false,
            redirectToLogin: true
        });
    }

    handleCloseAlert = () => {
        this.props.hideAlert();
    }

    handleDisplayChange = (display: DisplayType) => {
        this.props.changeDisplay(display);
    }

    handleShowNotifications = () => {
        this.setState({
            showNotifications: true
        });
    }

    handleMarkNotificationRead = (id: number) => {
        this.props.showLoading('One moment please...').then(() => {
            this.props.markNotificationRead(id).then(response => {
                if (response.data.success) {
                    this.props.getCenterNotifications(this.props.app.center.id).then(centerResponse => {
                        this.props.hideLoading();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });
    }

    showBrowserWarning = () => {
        let approvedBrowsers = ['chrome', 'firefox', 'ios'];
        let browser = detect();

        return browser && (approvedBrowsers.indexOf(browser.name) < 0);
    }

    getCenterId = () => {
        let centerId = this.props.app.user ? this.props.app.user.centerId : 0;

        if (centerId == 0) {
            if (this.props.app.center) {
                centerId = this.props.app.center.id;
            }
        }

        return centerId;
    }

    getUserGroupAndRoles = () => {
        let firstName = this.props.app.user ? this.props.app.user.firstName : '';
        let lastName = this.props.app.user ? this.props.app.user.lastName : '';
        let username = this.props.app.user ? this.props.app.user.username : '';
        let userCenterAlias = this.props.app.user ? this.props.app.user.centerAlias : '';
        let centerAlias = userCenterAlias ? userCenterAlias : this.state.centerAlias;
        let courierName = this.props.app.user ? this.props.app.user.courierName : '';
        let group = this.props.app.user ? this.props.app.user.group : null;
        let roles = this.props.app.user ? this.props.app.user.roles : null;
        let isLoginRequired = true;

        if (__NO_LOGIN_ADDRESSES__.indexOf(this.props.location.pathname) >= 0 && this.props.app.user == null) {
            firstName = 'NKR';
            lastName = 'Service Account';
            isLoginRequired = false;
        }

        return { firstName, lastName, username, userCenterAlias, centerAlias, group, roles, isLoginRequired, courierName };
    }

    render = () => {
        const { firstName, lastName, username, centerAlias, group, roles, isLoginRequired, courierName } = this.getUserGroupAndRoles();
        const currentUrl = encodeURIComponent(this.props.location.pathname + this.props.location.search);
        const notificationCount = this.props.centerNotifications.list.filter(x => x.isEnabled == true && x.isRead == false).length;
        const centerId = this.getCenterId();

        if (this.state.redirectToLogin && isLoginRequired)
            return <Redirect to={'/login?next=' + currentUrl} />;

        const showBrowserWarning = this.showBrowserWarning();
        const isMicrositeCoach = this.props.location.pathname.indexOf('/microsite/coach') >= 0;

        return (
            <>
                <div ref={this.saveContainer} />
                <div className='layout-main'>
                    <LoadingIndicator
                        type='spin'
                        color='black'
                        loading={this.props.app.loading}
                        message={this.props.app.loadingMessage}
                    />

                    {(this.props.app.display == DisplayType.All || this.props.app.display == DisplayType.MenuOnly) && (
                        <NavMenu
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}
                            firstName={firstName}
                            lastName={lastName}
                            username={username}
                            currentUrl={currentUrl}
                            group={group}
                            roles={roles}
                            isMicrositeCoach={isMicrositeCoach}
                            centerId={centerId}
                            centerAlias={centerAlias}
                            center={this.props.app.center}
                            showCenterMenu={this.props.match.path == '/center/:centerId'}
                            notifications={notificationCount}
                            isLoginRequired={isLoginRequired}
                            courierName={courierName}
                            onShowNotifications={this.handleShowNotifications}
                            onGetCenterList={this.props.getBasicCenterList}
                        />
                    )}

                    {showBrowserWarning && (
                        <Alert bsStyle='danger' style={{ padding: '7.5px 15px 7.5px 15px', textAlign: 'center' }}>
                            We recommend that you use either Chrome or Firefox when using this site.
                        </Alert>
                    )}

                    <div className={`layout-column ${this.props.app.site.organ}registry`} style={{ padding: centerId == 0 ? 10 : 0 }}>
                        {this.props.children}
                    </div>

                    <Modal show={this.props.app.alert.show} onHide={null}>
                        <Modal.Header>
                            {this.props.app.alert.title}
                        </Modal.Header>
                        <Modal.Body>
                            {this.props.app.alert.message}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button bsStyle='primary' onClick={this.handleCloseAlert}>Ok</Button>
                        </Modal.Footer>
                    </Modal>
                </div>

                <CenterNotifications
                    show={this.state.showNotifications}
                    list={this.props.centerNotifications.list}
                    onMarkRead={this.handleMarkNotificationRead}
                    onClose={() => this.setState({ showNotifications: false })}
                    onGetContainer={this.getContainer}
                />

                <ToastContainer
                    position={toast.POSITION.TOP_CENTER}
                    autoClose={2000}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
        centerNotifications: state.centerNotifications,
        auth: state.auth
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        storeAuth: (token, tokenHex) => {
            dispatch(AuthActionCreators.storeAuth(token, tokenHex));
        },
        validToken: () => {
            return dispatch(AuthActionCreators.validToken());
        },
        setUserProfile: (user) => {
            dispatch(AppActionCreators.setUserProfile(user));
        },
        refreshToken: () => {
            return dispatch(AuthActionCreators.refreshToken());
        },
        showAlert: (title, message) => {
            dispatch(AppActionCreators.showAlert(title, message));
        },
        hideAlert: () => {
            dispatch(AppActionCreators.hideAlert());
        },
        changeDisplay: (display) => {
            dispatch(AppActionCreators.changeDisplay(display));
        },
        getBaseCenter: (centerId) => {
            return dispatch(AppActionCreators.getBaseCenter(centerId));
        },
        getBasicCenterList: (liverOnly) => {
            return dispatch(CenterActionCreators.getBasicCenterList(liverOnly));
        },
        getCenterNotifications: (centerId) => {
            return dispatch(CenterNotificationActionCreators.getCenterNotifications(centerId));
        },
        markNotificationRead: (id) => {
            return dispatch(CenterNotificationActionCreators.markNotificationRead(id));
        },
        setSite: (payload) => {
            return dispatch(AppActionCreators.setSite(payload));
        }
    };
}

export default withRouter(connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Layout));
